import { render, staticRenderFns } from "./membership.vue?vue&type=template&id=96a4fa1e"
import script from "./membership.vue?vue&type=script&lang=js"
export * from "./membership.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports